/** @jsxImportSource @emotion/react */

import {Button, Modal} from 'antd'
import {nanoid} from 'nanoid'
import {fileFromClipboard} from 'script/file.mjs'

const ButtonPasteImage = ({onChange, ...props}) => {
    const handleClick = async () => {
        try {
            const file = await fileFromClipboard(
                'image/png',
                `${nanoid()}.png`
            )

            onChange(file)
        }
        catch (err) {
            Modal.error({content: err.message})
        }
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        />
    )
}

export default ButtonPasteImage
